import React from 'react'
import _ from 'lodash'
import LtsInputText from '../../components/lottus/lts-input-text'

export const formBuildInputText = ({ componentInfo, messages, record, onChange, label }) => {
  return (
    <div className="p-grid form-group">
      <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
        <LtsInputText
          value={record[_.get(componentInfo, 'campo', '')]}
          label={label}
          onChange={(e) => onChange(_.get(componentInfo, 'campo', null), e)}
          style={{ width: '100%' }}
        />
      </div>
    </div>
  )
}
